module.exports = __webpack_public_path__ + "img/scan-bg-desktop.5a5585a8.webp";